import { render, staticRenderFns } from "./pageSeven.vue?vue&type=template&id=ca4067ea&scoped=true&"
import script from "./pageSeven.vue?vue&type=script&lang=js&"
export * from "./pageSeven.vue?vue&type=script&lang=js&"
import style0 from "./pageSeven.vue?vue&type=style&index=0&id=ca4067ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4067ea",
  null
  
)

export default component.exports